import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

type EventDetailRowProps = {
  title: string;
  icon: JSX.Element;
  fontSize?: number;
  titleSpacing?: number;
};

export const EventDetailRow = (props: EventDetailRowProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        pt: 5,
        alignItems: 'center',
      }}
    >
      {props.icon}
      <Typography
        sx={{
          ml: props.titleSpacing ?? 5,
          fontSize: props.fontSize,
        }}
      >
        {props.title}
      </Typography>
    </Box>
  );
};
